/* bootstrap-vue collapse'ın $root olaylarının (toggle, state, accordion) Vue'dan bağımsız
   karşılığı. BaseCollapse kendini id ile kaydeder;
   v-collapse-toggle ve SideBarStyle.vue toggleCollapse(id) çağırır. Aynı id'li birden çok
   kayıt olabilir (bootstrap-vue'da olay hepsine gider). */

const collapses = new Map(); // id → Set<instance>
const stateListeners = new Set(); // (id, visible) => void

export function registerCollapse(id, instance) {
    if (!id) return;
    if (!collapses.has(id)) collapses.set(id, new Set());
    collapses.get(id).add(instance);
}

export function unregisterCollapse(id, instance) {
    const set = collapses.get(id);
    if (!set) return;
    set.delete(instance);
    if (!set.size) collapses.delete(id);
}

export function toggleCollapse(id) {
    const set = collapses.get(id);
    if (set) Array.from(set).forEach(instance => instance.toggle());
}

/* Akordeon: bir panel açılınca aynı gruptaki diğer açık paneller kapanır. */
export function openedInAccordion(openedId, accordion) {
    collapses.forEach((set, id) => {
        set.forEach(instance => {
            if (!instance.accordion || instance.accordion !== accordion) return;
            const isThis = id === openedId;
            if ((isThis && !instance.show) || (!isThis && instance.show)) instance.toggle();
        });
    });
}

export function emitCollapseState(id, visible) {
    Array.from(stateListeners).forEach(listener => listener(id, visible));
}

export function onCollapseState(listener) {
    stateListeners.add(listener);
}

export function offCollapseState(listener) {
    stateListeners.delete(listener);
}

/* Toggle ilk bağlandığında hedefin durumunu ister (bootstrap-vue request-state olayı). */
export function requestCollapseState(id) {
    const set = collapses.get(id);
    if (set) set.forEach(instance => instance.$nextTick(() => emitCollapseState(id, instance.show)));
}
